module.exports = __webpack_public_path__ + "img/attractions-field.96206e05.jpg";